import { schema } from "normalizr";

export const paintingPreviewSchema = new schema.Entity("paintingPreviews");
export const paintingSchema = new schema.Entity("paintings");